// "Continue with Google" — hand-rendered per Google's branding guidelines
// (https://developers.google.com/identity/branding-guidelines): the official
// multi-color G (never recolored), light theme #FFFFFF fill / #747775 stroke /
// #1F1F1F text, dark theme #131314 / #8E918F / #E3E3E3, medium 14px label,
// 20px logo with ~10px gap. These exact hexes are REQUIRED by the guidelines,
// so they deliberately bypass the --skwc/theme token system.

export function GoogleGIcon({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path
        d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z"
        fill="#4285F4"
      />
      <path
        d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
        fill="#34A853"
      />
      <path
        d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
        fill="#FBBC05"
      />
      <path
        d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
        fill="#EA4335"
      />
    </svg>
  );
}

export function GoogleButton({
  label,
  onClick,
  disabled,
}: {
  label: string;
  onClick: () => void;
  disabled?: boolean;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={
        // Same height and radius as the entry controls beside it (40 px, 44 on
        // touch; the 8 px control radius).
        'flex h-10 w-full items-center justify-center gap-2.5 rounded-sm border px-3 pointer-coarse:min-h-11 ' +
        'text-sm font-medium transition-colors disabled:opacity-50 ' +
        'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring ' +
        'border-[#747775] bg-white text-[#1F1F1F] hover:bg-[#f6f6f6] ' +
        'dark:border-[#8E918F] dark:bg-[#131314] dark:text-[#E3E3E3] dark:hover:bg-[#1e1e20]'
      }
    >
      <GoogleGIcon className="size-5 shrink-0" />
      {label}
    </button>
  );
}
